/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-todo-list block)");
/* eslint-enable no-console */



(function () {
    'use strict';

    /* ── Helpers ── */
    const $ = id => document.getElementById(id);

    /* ── DOM refs ── */
    const colorPicker = $('colorPicker');
    const colorPreview = $('colorPreview');
    const hexInput = $('hexInput');
    const lightnessSlider = $('lightnessSlider');
    const saturationSlider = $('saturationSlider');
    const lightnessHint = $('lightnessHint');
    const saturationHint = $('saturationHint');
    const hexDisplay = $('hexDisplay');
    const hexSwatch = $('hexSwatch');
    const hexText = $('hexText');
    const hslText = $('hslText');
    const timerEnabledEl = $('timerEnabled');
    const timerMinutesEl = $('timerMinutes');
    const timerActionEl = $('timerAction');
    const burnInEnabledEl = $('burnInEnabled');
    const burnInModeEl = $('burnInMode');
    const burnInSpeedEl = $('burnInSpeed');
    const osd = $('osd');
    const osdTimer = $('osdTimer');
    const osdBurnIn = $('osdBurnIn');
    const timerBar = $('timerBar');
    const timerCountdown = $('timerCountdown');
    const toast = $('toast');
    const imgWidth = $('imgWidth');
    const imgHeight = $('imgHeight');
    const imgDpi = $('imgDpi');
    const imgFormat = $('imgFormat');
    const downloadInfo = $('downloadInfo');
    const shareModal = $('shareModal');
    const fullscreenScreen = $('fullscreenScreen');

    /* ── State ── */
    let baseHsl = { h: 0, s: 0, l: 100 };
    let timerHandle = null, timerEnd = null, timerTickId = null;
    let burnInId = null, burnInPhase = 0, toastTimer = null;

    const DEFAULTS = {
        picker: colorPicker.value, lightness: 100, saturation: 0,
        width: 1920, height: 1080, dpi: '300',
        format: 'image/png', timerMinutes: 10
    };
    const BASE_URL = 'https://www.whitescreen.top/';

    /* ── Color utils ── */
    function hexToRgb(hex) {
        const c = hex.replace('#', '');
        const v = c.length === 3 ? c.split('').map(x => x + x).join('') : c;
        const n = parseInt(v, 16);
        return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
    }

    function rgbToHsl(r, g, b) {
        r /= 255; g /= 255; b /= 255;
        const max = Math.max(r, g, b), min = Math.min(r, g, b);
        let h = 0, s = 0, l = (max + min) / 2;
        if (max !== min) {
            const d = max - min;
            s = l > .5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                default: h = (r - g) / d + 4;
            }
            h /= 6;
        }
        return { h: Math.round(h * 360), s: Math.round(s * 100), l: Math.round(l * 100) };
    }

    function hslToHex(h, s, l) {
        s /= 100; l /= 100;
        const k = n => (n + h / 30) % 12;
        const a = s * Math.min(l, 1 - l);
        const f = n => Math.round((l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))) * 255);
        return '#' + [f(0), f(8), f(4)].map(v => v.toString(16).padStart(2, '0')).join('');
    }

    function getHsl(hOvr, lOvr) {
        return {
            h: hOvr !== undefined ? hOvr : baseHsl.h,
            s: +saturationSlider.value,
            l: lOvr !== undefined ? lOvr : +lightnessSlider.value
        };
    }

    function hslStr(h, s, l) { return `hsl(${h} ${s}% ${l}%)`; }
    function getColor(hOvr, lOvr) { const { h, s, l } = getHsl(hOvr, lOvr); return hslStr(h, s, l); }

    function updatePreview() {
        const { h, s, l } = getHsl();
        const hex = hslToHex(h, s, l);
        colorPreview.style.background = hslStr(h, s, l);
        lightnessHint.innerHTML = `Brightness: <strong>${l}%</strong>`;
        saturationHint.innerHTML = `Saturation: <strong>${s}%</strong>`;
        hexSwatch.style.background = hex;
        hexText.textContent = hex.toUpperCase();
        hslText.innerHTML = `hsl(${h}, ${s}%, ${l}%)`;
        hexInput.value = hex.toUpperCase();
    }

    function syncFromPicker() {
        const { r, g, b } = hexToRgb(colorPicker.value);
        baseHsl = rgbToHsl(r, g, b);
        saturationSlider.value = baseHsl.s;
        lightnessSlider.value = baseHsl.l;
        updatePreview();
    }

    /* ── Color picker & hex input ── */
    colorPicker.addEventListener('input', () => {
        hexInput.value = colorPicker.value.toUpperCase();
        syncFromPicker();
    });

    hexInput.addEventListener('input', () => {
        let val = hexInput.value.trim();
        if (!val.startsWith('#')) val = '#' + val;
        if (/^#[0-9a-fA-F]{6}$/.test(val)) { colorPicker.value = val; syncFromPicker(); }
    });

    hexInput.addEventListener('blur', () => {
        if (!/^#[0-9a-fA-F]{6}$/i.test(hexInput.value.trim()))
            hexInput.value = colorPicker.value.toUpperCase();
    });

    hexInput.addEventListener('keydown', e => { if (e.key === 'Enter') hexInput.blur(); });
    lightnessSlider.addEventListener('input', updatePreview);
    saturationSlider.addEventListener('input', updatePreview);

    /* ── Toast ── */
    function showToast(msg) {
        toast.textContent = msg;
        toast.classList.add('show');
        clearTimeout(toastTimer);
        toastTimer = setTimeout(() => toast.classList.remove('show'), 2200);
    }

    hexDisplay.addEventListener('click', async () => {
        try { await navigator.clipboard.writeText(hexText.textContent); showToast('✅ HEX code copied!'); } catch (e) { }
    });
    // ✅ Délégation sur le conteneur déjà présent dans ton PHP
    document.querySelector('.color-swatches').addEventListener('click', async e => {
        const btn = e.target.closest('.swatch-copy');
        if (!btn) return;
        e.stopPropagation();
        const hex = btn.closest('.swatch-info').querySelector('.swatch-hex').textContent;
        try {
            await navigator.clipboard.writeText(hex);
            showToast('✅ HEX code copied: ' + hex);
            btn.style.color = '#27ae60'; btn.style.borderColor = '#27ae60';
            setTimeout(() => { btn.style.color = ''; btn.style.borderColor = ''; }, 1500);
        } catch (e) { }
    });
    /* ── Reset ── */
    function resetAll() {
        colorPicker.value = DEFAULTS.picker;
        lightnessSlider.value = DEFAULTS.lightness;
        saturationSlider.value = DEFAULTS.saturation;
        timerEnabledEl.checked = burnInEnabledEl.checked = false;
        timerMinutesEl.value = DEFAULTS.timerMinutes;
        timerActionEl.value = 'exit';
        burnInModeEl.value = 'hue';
        burnInSpeedEl.value = '30000';
        imgWidth.value = DEFAULTS.width;
        imgHeight.value = DEFAULTS.height;
        imgDpi.value = DEFAULTS.dpi;
        imgFormat.value = DEFAULTS.format;
        syncFromPicker();
        updateDownloadInfo();
    }

    $('resetAll').addEventListener('click', resetAll);

    /* ── Share modal ── */
    function buildShareData() {
        const hex = hexText.textContent.replace('#', '');
        const l = lightnessSlider.value, s = saturationSlider.value;
        const url = `${BASE_URL}`;
        const iframe = `<iframe src="${url}" width="800" height="450" style="border:none;display:block;" title="White Screen — #${hex}" loading="lazy" allowfullscreen></iframe>`;
        return { url, iframe };
    }

    $('shareBtn').addEventListener('click', () => {
        const { url, iframe } = buildShareData();
        $('shareUrl').textContent = url;
        $('shareIframe').textContent = iframe;
        shareModal.classList.add('open');
    });

    $('modalClose').addEventListener('click', () => shareModal.classList.remove('open'));
    shareModal.addEventListener('click', e => { if (e.target === shareModal) shareModal.classList.remove('open'); });

    $('copyUrlBtn').addEventListener('click', async () => {
        try { await navigator.clipboard.writeText($('shareUrl').textContent); showToast('✅ Link copied!'); } catch (e) { }
    });

    $('copyIframeBtn').addEventListener('click', async () => {
        try { await navigator.clipboard.writeText($('shareIframe').textContent); showToast('✅ iFrame copied!'); } catch (e) { }
    });

    /* ── Fullscreen ── */
    $('enterFullscreen').addEventListener('click', () => {
        fullscreenScreen.style.background = getColor();
        fullscreenScreen.style.display = 'block';
        fullscreenScreen.requestFullscreen().catch(() => { });
    });

    document.addEventListener('fullscreenchange', () => {
        if (document.fullscreenElement) {
            osd.style.display = 'flex'; startTimer(); startBurnIn();
        } else {
            fullscreenScreen.style.display = 'none'; fullscreenScreen.style.background = '';
            osd.style.display = 'none'; stopTimer(); stopBurnIn();
        }
    });

    fullscreenScreen.addEventListener('click', () => document.exitFullscreen());

    /* ── Timer ── */
    function fmtTime(ms) {
        const s = Math.ceil(ms / 1000), m = Math.floor(s / 60);
        return m > 0 ? `${m}m ${String(s % 60).padStart(2, '0')}s` : `${s}s`;
    }

    function startTimer() {
        stopTimer();
        if (!timerEnabledEl.checked) return;
        const dur = +timerMinutesEl.value * 60000;
        timerEnd = Date.now() + dur;
        osdTimer.style.display = timerBar.style.display = 'block';
        timerTickId = setInterval(() => {
            const left = timerEnd - Date.now();
            if (left <= 0) { stopTimer(); applyTimerAction(); return; }
            const t = fmtTime(left);
            osdTimer.textContent = `⏱ ${t}`;
            timerCountdown.textContent = t;
        }, 500);
        timerHandle = setTimeout(() => { stopTimer(); applyTimerAction(); }, dur);
    }

    function stopTimer() {
        clearTimeout(timerHandle); clearInterval(timerTickId);
        timerHandle = timerEnd = null;
        osdTimer.style.display = timerBar.style.display = 'none';
    }

    function applyTimerAction() {
        timerActionEl.value === 'exit' ? document.exitFullscreen()
            : (fullscreenScreen.style.background = '#000', stopBurnIn());
    }

    timerBar.addEventListener('click', stopTimer);

    /* ── Anti burn-in ── */
    function startBurnIn() {
        stopBurnIn();
        if (!burnInEnabledEl.checked) return;
        osdBurnIn.style.display = 'block';
        const speed = +burnInSpeedEl.value, mode = burnInModeEl.value;
        const baseL = +lightnessSlider.value, baseH = baseHsl.h;
        burnInPhase = 0;
        burnInId = setInterval(() => {
            burnInPhase = (burnInPhase + 1) % 360;
            const sin = Math.sin((burnInPhase / 360) * Math.PI * 2);
            const h = mode !== 'lightness' ? (baseH + Math.round(sin * 15) + 360) % 360 : baseH;
            const l = mode !== 'hue' ? Math.max(5, Math.min(95, baseL + Math.round(sin * 8))) : baseL;
            fullscreenScreen.style.background = getColor(h, l);
        }, Math.max(16, Math.round(speed / 360)));
    }

    function stopBurnIn() { clearInterval(burnInId); burnInId = null; osdBurnIn.style.display = 'none'; }

    /* ── Download ── */
    document.querySelectorAll('.preset').forEach(btn => {
        btn.addEventListener('click', () => {
            imgWidth.value = btn.dataset.w; imgHeight.value = btn.dataset.h;
            imgDpi.value = btn.dataset.dpi; updateDownloadInfo();
        });
    });

    function updateDownloadInfo() {
        const w = +imgWidth.value || 0, h = +imgHeight.value || 0;
        const dpi = +imgDpi.value || 72, fmt = imgFormat.value;
        const wCm = ((w / dpi) * 2.54).toFixed(1), hCm = ((h / dpi) * 2.54).toFixed(1);
        let sizeLabel;
        if (fmt === 'image/svg+xml') {
            sizeLabel = `<strong>~200 B</strong> <span style="color:#27ae60;font-weight:700">(vector — infinite resolution)</span>`;
        } else {
            const bpp = fmt === 'image/png' ? 3 : fmt === 'image/jpeg' ? .5 : .4;
            const kb = Math.round((w * h * bpp) / 1024);
            const sz = kb > 1024 ? (kb / 1024).toFixed(1) + ' MB' : kb + ' KB';
            sizeLabel = `<strong>~${sz}</strong>`;
            if (w >= 7680 || h >= 4320) sizeLabel += ` &nbsp;<strong style="color:#e74c3c">⚠ very heavy resolution</strong>`;
        }
        downloadInfo.innerHTML =
            `Size: <strong>${w} × ${h} px</strong> &nbsp;|&nbsp; Physical: <strong>${wCm} × ${hCm} cm</strong> at ${dpi} DPI &nbsp;|&nbsp; Estimated size: ${sizeLabel}`;
    }

    [imgWidth, imgHeight, imgDpi, imgFormat].forEach(el => {
        el.addEventListener('input', updateDownloadInfo);
        el.addEventListener('change', updateDownloadInfo);
    });

    function exportSvg(w, h) {
        const hex = hexText.textContent;
        const svg = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}">
  <rect width="${w}" height="${h}" fill="${hex}"/>
</svg>`;
        const a = Object.assign(document.createElement('a'), {
            href: URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml;charset=utf-8' })),
            download: `screen-${hex.replace('#', '')}-${w}x${h}.svg`
        });
        a.click(); URL.revokeObjectURL(a.href);
    }

    function exportRaster(w, h, fmt) {
        const ext = fmt === 'image/png' ? 'png' : fmt === 'image/jpeg' ? 'jpg' : 'webp';
        const canvas = Object.assign(document.createElement('canvas'), { width: w, height: h });
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = getColor(); ctx.fillRect(0, 0, w, h);
        canvas.toBlob(blob => {
            if (!blob) return;
            const a = Object.assign(document.createElement('a'), {
                href: URL.createObjectURL(blob),
                download: `screen-${hexText.textContent.replace('#', '')}-${w}x${h}.${ext}`
            });
            a.click(); URL.revokeObjectURL(a.href);
        }, fmt, fmt === 'image/jpeg' ? .95 : undefined);
    }

    $('downloadBtn').addEventListener('click', () => {
        const w = +imgWidth.value || 1920, h = +imgHeight.value || 1080, fmt = imgFormat.value;
        fmt === 'image/svg+xml' ? exportSvg(w, h) : exportRaster(w, h, fmt);
    });

    /* ── Noise Generator ── */
    (function () {
        let actx = null, node = null, gain = null;

        function whiteBuf(ctx) {
            const buf = ctx.createBuffer(1, 2 * ctx.sampleRate, ctx.sampleRate);
            const d = buf.getChannelData(0);
            for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
            const s = ctx.createBufferSource(); s.buffer = buf; s.loop = true; return s;
        }

        function filteredBuf(ctx, type, freq, Q, gain_) {
            const s = whiteBuf(ctx);
            const f = ctx.createBiquadFilter();
            f.type = type; f.frequency.value = freq;
            if (Q !== undefined) f.Q.value = Q;
            if (gain_ !== undefined) f.gain.value = gain_;
            s.connect(f);
            return { connect: d => f.connect(d), start: () => s.start(0), stop: () => s.stop() };
        }

        function scriptNode(ctx, fn) {
            const sp = ctx.createScriptProcessor(4096, 1, 1);
            sp.onaudioprocess = e => fn(e.outputBuffer.getChannelData(0));
            return sp;
        }

        const processors = {
            white: ctx => whiteBuf(ctx),
            pink: ctx => scriptNode(ctx, o => {
                let b0 = 0, b1 = 0, b2 = 0, b3 = 0, b4 = 0, b5 = 0, b6 = 0;
                for (let i = 0; i < 4096; i++) { const w = Math.random() * 2 - 1; b0 = .99886 * b0 + w * .0555179; b1 = .99332 * b1 + w * .0750759; b2 = .969 * b2 + w * .153852; b3 = .8665 * b3 + w * .3104856; b4 = .55 * b4 + w * .5329522; b5 = -.7616 * b5 - w * .016898; o[i] = (b0 + b1 + b2 + b3 + b4 + b5 + b6 + w * .5362) * .11; b6 = w * .115926; }
            }),
            brown: ctx => { let last = 0; return scriptNode(ctx, o => { for (let i = 0; i < 4096; i++) { const w = Math.random() * 2 - 1; o[i] = (last + .02 * w) / 1.02; last = o[i]; o[i] *= 3.5; } }); },
            blue: ctx => { let last = 0; return scriptNode(ctx, o => { for (let i = 0; i < 4096; i++) { const w = Math.random() * 2 - 1; o[i] = (w - last) * .5; last = w; } }); },
            violet: ctx => { let last = 0; return scriptNode(ctx, o => { for (let i = 0; i < 4096; i++) { const w = Math.random() * 2 - 1; o[i] = w - last; last = w; } }); },
            grey: ctx => filteredBuf(ctx, 'peaking', 3000, undefined, -6),
            green: ctx => filteredBuf(ctx, 'bandpass', 500, 0.5),
            black: ctx => filteredBuf(ctx, 'lowpass', 20),
            velvet: ctx => scriptNode(ctx, o => { for (let i = 0; i < 4096; i++) o[i] = Math.random() < .001 ? (Math.random() > .5 ? 1 : -1) : 0; }),
            // Red = alias Brown (même algorithme, nom alternatif)
            red: ctx => {
                let last = 0;
                return scriptNode(ctx, o => {
                    for (let i = 0; i < 4096; i++) {
                        const w = Math.random() * 2 - 1;
                        o[i] = (last + .02 * w) / 1.02;
                        last = o[i]; o[i] *= 3.5;
                    }
                });
            },

            // Orange = entre Brown et Pink (~-4.5 dB/oct)
            orange: ctx => {
                let b0 = 0, b1 = 0, b2 = 0, last = 0;
                return scriptNode(ctx, o => {
                    for (let i = 0; i < 4096; i++) {
                        const w = Math.random() * 2 - 1;
                        b0 = .99886 * b0 + w * .0555179;
                        b1 = .99332 * b1 + w * .0750759;
                        b2 = .969 * b2 + w * .153852;
                        const pink = (b0 + b1 + b2) * .18;
                        const brown = (last + .02 * w) / 1.02; last = brown;
                        o[i] = (pink + brown * 3.5) * .5;
                    }
                });
            },

            // Cyan = bandpass centré ~2kHz (aigus-médiums)
            cyan: ctx => filteredBuf(ctx, 'bandpass', 2000, 0.8),

            // Gold = Brown + boost léger des médiums
            gold: ctx => {
                const s = whiteBuf(ctx);
                const f1 = ctx.createBiquadFilter();
                f1.type = 'lowshelf'; f1.frequency.value = 200; f1.gain.value = 10;
                const f2 = ctx.createBiquadFilter();
                f2.type = 'highcut' in ctx ? 'lowpass' : 'lowpass'; f2.frequency.value = 800;
                s.connect(f1); f1.connect(f2);
                return { connect: d => f2.connect(d), start: () => s.start(0), stop: () => s.stop() };
            },

            // Silver = bruit blanc passe-haut doux (brillant mais pas agressif)
            silver: ctx => filteredBuf(ctx, 'highpass', 1200),
            yellow: ctx => {
                const s = whiteBuf(ctx);
                const notch = ctx.createBiquadFilter();
                notch.type = 'notch';
                notch.frequency.value = 1000;
                notch.Q.value = 0.3;
                s.connect(notch);
                return { connect: d => notch.connect(d), start: () => s.start(0), stop: () => s.stop() };
            }
        };

        function stopNoise() {
            if (node) { try { node.stop ? node.stop() : node.disconnect(); node.disconnect(); } catch (e) { } node = null; }
            $('noisePlay').style.display = 'inline-flex';
            $('noiseStop').style.display = 'none';
        }

        $('noisePlay').addEventListener('click', () => {
            stopNoise();
            if (!actx) actx = new (window.AudioContext || window.webkitAudioContext)();
            if (actx.state === 'suspended') actx.resume();
            gain = actx.createGain(); gain.gain.value = .5; gain.connect(actx.destination);
            node = processors[$('noiseType').value](actx);
            node.connect(gain);
            if (node.start) node.start(0);
            $('noisePlay').style.display = 'none';
            $('noiseStop').style.display = 'inline-flex';
        });

        $('noiseStop').addEventListener('click', stopNoise);
        document.addEventListener('fullscreenchange', () => { if (!document.fullscreenElement) stopNoise(); });
    })();




    /* ── Init ── */
    function init() {
        // Lit hexInput (type text, non normalisé par le navigateur)
        const raw = hexInput.value.trim();
        const hex = /^#[0-9a-fA-F]{6}$/.test(raw) ? raw : '#ffffff';

        // Synchronise colorPicker avec la valeur PHP
        colorPicker.value = hex.toLowerCase();

        // Calcule et applique le HSL réel
        const { r, g, b } = hexToRgb(hex);
        baseHsl = rgbToHsl(r, g, b);

        // Cale les sliders AVANT updatePreview
        lightnessSlider.value = baseHsl.l;
        saturationSlider.value = baseHsl.s;

        // Met à jour l'affichage
        updatePreview();

        // Reste des defaults (ne touche pas aux sliders)
        timerMinutesEl.value = DEFAULTS.timerMinutes;
        imgWidth.value = DEFAULTS.width;
        imgHeight.value = DEFAULTS.height;
        imgDpi.value = DEFAULTS.dpi;
        imgFormat.value = DEFAULTS.format;
        updateDownloadInfo();
    }


    /* ── Init ── */
    init(); // ← remplace resetAll() en bas




})();